<template>
    <div class="font-roboto">
        <Breadcrumbs main="" :title="$t('lbl_EMPBE_VisitorGuide')" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header customStickyCardHeader">
                        <h3 v-html="$t('lbl_EMPBE_VisitorGuideTitle')"></h3>
                        <h6 v-html="$t('lbl_EMPBE_VisitorGuideDesc')"></h6>
                    </div>
                    <div class="card-body card-min-height py-2">
                        <div class="row">
                            <vgSelector @form_vgSelected="form_vgSelected" v-for="(data,i) in vgSelectorData" :data="data" v-bind:key="i"></vgSelector>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        
        <div class="customizer-formbutton">
                <b-button-group>
                  <button type="button" class="btn btn-success btn-lg" @click="submitVisitorGuide"
                    v-bind:t_label="'EMPBE_VisitorCenter_btnSubmit'" :disabled="IsLockDate">
                    <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_SaveAndSubmit") }}
                  </button>
                </b-button-group>
        </div>

              <vgSideBar  ref="sidebar"></vgSideBar>
    </div>
</template>

<script>
    import { map } from "leaflet";
    import vgSelector from "./component/vgSelector";
    import  vgSideBar  from "./component/vgSideBar";
    import { productService } from '@/_services/product.service';

    export default{
        data(){
            return{
                form:{
                    vgSelection:[]
                },
                UserVG : [],
                vgSelectorData : []
            }

        },
        components:{
            vgSelector,
            vgSideBar
        },
        mounted(){
            this.UserVG = this.LoadUserVisitorGuide()
        },
        methods:{
            form_vgSelected(formObj, formid){
                //remove repeated product if the user changes product in the same dropdown
                this.form.vgSelection  = this.form.vgSelection.filter(x=> x.vgId != formid)

                //append product to form list               
                if(formObj.productId){
                    this.form.vgSelection.push(formObj)
                }
                
            },
            submitVisitorGuide(){
                var query = this.GetVGSumbitQuery(this.form.vgSelection)
                if(this.form.vgSelection.length){
                    productService.SumbitVisitorGuide(query).then(res => {
                    if(res.isSuccessful){
                        this.$swal({
                            text: this.$t("lbl_EMPBE_SubmitSuccess") + "!",
                            showCancelButton: false,
                            confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
                            cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
                        });
                    }
                    else{
                    }
                });
                }
            },
            GetVGSumbitQuery(vgSelection){
                var query = {
                    accountid : this.user.empCompanyId,
                    productIdCSV : vgSelection.map(x=>x.productId).join() ,
                    vgRidCSV : vgSelection.map(x=>x.vgId).join() 
                }
                return query;
            },
            LoadUserVisitorGuide(){
                var query ={
                    accountid : this.user.empCompanyId
                }
                productService.GetUserVisitorGuie(query).then( res =>{
                        if (res.isSuccessful){
                            this.UserVG = res.data;
                            this.vgSelectorData = this.GetvgSelectorData();
                        }
                    }
                    
                )
            },
            GetvgSelectorData(){ 
                var vgPackages = this.user.extraPermissions.vgPackages
                var vgSelectedDatum = []
                vgPackages.forEach((item) => {
                    
                    var vgSelectedData = {
                        type : item.type,
                        rid : item.rid,
                        //Get User Selected VG
                        productid : this.UserVG.filter(x=> x.rid == item.rid)[0]?.exhibitId
                    }
                    vgSelectedDatum.push(vgSelectedData)

                })
                return vgSelectedDatum
            },
            
        },
        computed:{
            user() {
                return this.$store.state.authentication.user;
            },

            IsLockDate(){
                return new Date() > new Date('2024-02-03')
            }
        },
        
    }
</script>

<style>
.card-min-height {
    min-height:500px !important;
}
</style>